import { Register } from "src/screens/Public/Register";
import { MenuItem } from "../../../../commons/ui/menu";

export const routes: MenuItem[] = [
  {
    key: "publicRegisterMain",
    basePath: "/",
    target: {
      component: Register,
      path: "/",
    },
    enabled: true,
    icon: "List",
    text: "Registro",
    children: [],
    default: true,
  },
];
